function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M267.135 190.527C264.648 190.74 262.147 190.707 259.668 190.427C232.41 187.42 195.291 188.276 165.033 206.982C123.187 232.849 57.6052 210.705 28.6759 198.658C6.57195 189.456 -4.90324 166.92 1.98942 145.765C2.08646 145.467 2.1862 145.168 2.29133 144.869C6.62856 132.298 15.1898 122.459 25.7916 117.244C35.0322 112.698 48.5237 103.206 54.5268 84.9673C57.0067 77.4362 60.4086 70.3515 64.8267 64.176C76.6577 47.6371 101.425 23.0076 144.021 23.1609C151.489 23.197 158.902 24.4489 165.966 26.8673C181.528 32.1579 195.582 42.914 206.3 57.8257C213.139 67.3364 223.388 76.1774 238.06 76.8983C258.422 77.9042 277.855 87.3638 292.433 104.199C292.853 104.683 293.269 105.17 293.684 105.662C319.64 136.515 301.611 187.52 267.135 190.527Z",
  fill: "#708390"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M74.7922 187.501C76.8467 187.501 78.5121 185.839 78.5121 183.789C78.5121 181.739 76.8467 180.077 74.7922 180.077C72.7377 180.077 71.0723 181.739 71.0723 183.789C71.0723 185.839 72.7377 187.501 74.7922 187.501Z",
  fill: "url(#paint0_linear)"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M74.7926 187.334C76.7547 187.334 78.3454 185.747 78.3454 183.789C78.3454 181.831 76.7547 180.244 74.7926 180.244C72.8304 180.244 71.2397 181.831 71.2397 183.789C71.2397 185.747 72.8304 187.334 74.7926 187.334Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.7507 112.763C55.51 112.763 56.1255 112.148 56.1255 111.391C56.1255 110.633 55.51 110.019 54.7507 110.019C53.9915 110.019 53.376 110.633 53.376 111.391C53.376 112.148 53.9915 112.763 54.7507 112.763Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.871 192.377C153.63 192.377 154.246 191.763 154.246 191.006C154.246 190.248 153.63 189.634 152.871 189.634C152.112 189.634 151.496 190.248 151.496 191.006C151.496 191.763 152.112 192.377 152.871 192.377Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.9152 198.765C95.3395 198.765 95.6835 198.422 95.6835 197.999C95.6835 197.576 95.3395 197.232 94.9152 197.232C94.4909 197.232 94.147 197.576 94.147 197.999C94.147 198.422 94.4909 198.765 94.9152 198.765Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.008 161.648C265.432 161.648 265.776 161.305 265.776 160.881C265.776 160.458 265.432 160.115 265.008 160.115C264.584 160.115 264.24 160.458 264.24 160.881C264.24 161.305 264.584 161.648 265.008 161.648Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.07 92.7916C221.494 92.7916 221.838 92.4484 221.838 92.0251C221.838 91.6017 221.494 91.2585 221.07 91.2585C220.645 91.2585 220.301 91.6017 220.301 92.0251C220.301 92.4484 220.645 92.7916 221.07 92.7916Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.338 126.413C283.762 126.413 284.106 126.07 284.106 125.646C284.106 125.223 283.762 124.88 283.338 124.88C282.914 124.88 282.57 125.223 282.57 125.646C282.57 126.07 282.914 126.413 283.338 126.413Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.011 67.8448C79.7703 67.8448 80.3858 67.2306 80.3858 66.473C80.3858 65.7155 79.7703 65.1013 79.011 65.1013C78.2517 65.1013 77.6362 65.7155 77.6362 66.473C77.6362 67.2306 78.2517 67.8448 79.011 67.8448Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2271 159.286H40.0032V158.065H39.5046V159.286H38.2808V159.784H39.5046V161.002H40.0032V159.784H41.2271V159.286Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.9566 158.748H70.7328V157.527H70.2341V158.748H69.0103V159.246H70.2341V160.464H70.7328V159.246H71.9566V158.748Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.895 183.493H114.671V182.272H114.173V183.493H112.949V183.991H114.173V185.209H114.671V183.991H115.895V183.493Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.093 35.1569H176.535V34.6002H176.308V35.1569H175.75V35.3829H176.308V35.9396H176.535V35.3829H177.093V35.1569Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.613 86.2611H256.055V85.7043H255.829V86.2611H255.271V86.487H255.829V87.0438H256.055V86.487H256.613V86.2611Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.71 119.613H209.152V119.056H208.926V119.613H208.368V119.839H208.926V120.396H209.152V119.839H209.71V119.613Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.861 140.593H18.303V140.036H18.0765V140.593H17.5186V140.819H18.0765V141.376H18.303V140.819H18.861V140.593Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.7736 186.318H41.2156V185.761H40.9891V186.318H40.4312V186.543H40.9891V187.1H41.2156V186.543H41.7736V186.318Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.746 41.8812H113.188V41.3244H112.962V41.8812H112.404V42.1071H112.962V42.6639H113.188V42.1071H113.746V41.8812Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.7819 122.303H79.2239V121.746H78.9974V122.303H78.4395V122.529H78.9974V123.086H79.2239V122.529H79.7819V122.303Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.0597 99.1716H86.5017V98.6148H86.2753V99.1716H85.7173V99.3975H86.2753V99.9543H86.5017V99.3975H87.0597V99.1716Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M201.672 152.551C203.387 152.551 204.777 151.164 204.777 149.453C204.777 147.741 203.387 146.354 201.672 146.354C199.957 146.354 198.566 147.741 198.566 149.453C198.566 151.164 199.957 152.551 201.672 152.551Z",
  fill: "url(#paint1_linear)"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M201.672 152.323C203.26 152.323 204.548 151.038 204.548 149.453C204.548 147.868 203.26 146.583 201.672 146.583C200.083 146.583 198.795 147.868 198.795 149.453C198.795 151.038 200.083 152.323 201.672 152.323Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M209.416 172.864C211.192 172.864 212.632 171.427 212.632 169.655C212.632 167.883 211.192 166.446 209.416 166.446C207.64 166.446 206.2 167.883 206.2 169.655C206.2 171.427 207.64 172.864 209.416 172.864Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M180.598 82.5816C180.62 75.8404 179.001 69.1947 175.88 63.2158C174.4 60.4078 173.05 58.6649 172.009 57.5917C171.612 57.1727 171.093 56.8887 170.525 56.7797C169.957 56.6706 169.37 56.742 168.845 56.9838C168.425 57.1323 168.046 57.3764 167.737 57.6966C166.332 59.149 165.063 61.0694 163.963 63.1109C160.682 69.2324 158.98 76.0727 159.011 83.0146V87.1783H156.334V38.7612C156.334 28.6156 154.059 18.6073 149.595 9.73132C147.482 5.52465 145.552 2.91027 144.072 1.30452C143.713 0.895872 143.27 0.568447 142.774 0.344133C142.278 0.11982 141.739 0.00378418 141.195 0.00378418C140.65 0.00378418 140.111 0.11982 139.615 0.344133C139.119 0.568447 138.676 0.895872 138.317 1.30452C136.311 3.48048 134.5 6.35845 132.926 9.41663C128.238 18.4863 125.858 28.7824 125.858 39.2238V87.1594H123.545V82.7941C123.574 75.8567 121.873 69.0211 118.593 62.9038C117.485 60.8623 116.216 58.9419 114.819 57.4895C114.414 57.0597 113.881 56.7708 113.299 56.6653C112.717 56.5598 112.116 56.6431 111.585 56.9031L111.682 56.9542C111.343 57.1045 111.037 57.3182 110.779 57.5836C109.741 58.6595 108.39 60.3997 106.91 63.2078C103.79 69.1867 102.171 75.8324 102.193 82.5735V154.926H110.452L109.541 160.873V178.66H116.297V160.873L115.393 154.924H123.534V89.0261H125.847V154.638H132.443L131.497 160.873V178.66H138.252V160.873L137.306 154.63H146.202L145.25 160.873V178.66H152.005V160.873L151.059 154.63H156.326V89.0342H159.003V155.031H161.173V154.932H168.349L167.448 160.873V178.66H174.204V160.873L173.301 154.924H180.598V82.5816Z",
  fill: "url(#paint2_linear)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M117.636 157.414H111.24L112.383 149.665H116.493L117.636 157.414Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M112.064 152.742H116.811L116.493 150.577H112.383L112.064 152.742Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M172.451 157.414H166.057L167.197 149.665H171.311L172.451 157.414Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M166.88 152.742H171.63L171.311 150.577H167.198L166.88 152.742Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M138.419 157.414H132.025L133.166 149.665H137.279L138.419 157.414Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M132.848 152.742H137.597L137.279 150.577H133.166L132.848 152.742Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M151.439 157.414H145.045L146.186 149.665H150.296L151.439 157.414Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M145.868 152.742H150.617L150.297 150.577H146.186L145.868 152.742Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M163.316 85.6263H117.636V87.4499H163.316V85.6263Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.376 56.8251C170.135 56.5591 169.84 56.3465 169.511 56.201C169.183 56.0554 168.827 55.9803 168.467 55.9803C168.108 55.9803 167.752 56.0554 167.423 56.201C167.095 56.3465 166.8 56.5591 166.559 56.8251C165.23 58.2399 164.028 60.1092 162.979 62.0969C159.869 68.0784 158.26 74.724 158.291 81.4627V151.621H178.509V81.1668C178.534 74.6146 177.003 68.1495 174.042 62.3013C172.638 59.5686 171.36 57.8579 170.376 56.8251Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.401 56.8251C112.643 56.5591 112.937 56.3465 113.266 56.201C113.595 56.0554 113.95 55.9803 114.31 55.9803C114.669 55.9803 115.025 56.0554 115.354 56.201C115.682 56.3465 115.977 56.5591 116.218 56.8251C117.55 58.2399 118.749 60.1092 119.801 62.0969C122.91 68.0789 124.518 74.7241 124.488 81.4627V151.621H104.271V81.1668C104.246 74.6146 105.777 68.1495 108.738 62.3013C110.14 59.5686 111.417 57.8579 112.401 56.8251Z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.387 82.6623L109.185 82.6865V88.5877H104.387V82.6623Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.69 82.6623L124.489 82.6865V88.5877H119.69V82.6623Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.292 82.6623L163.087 82.6865V88.5877H158.292V82.6623Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.594 82.6623L178.39 82.6865V88.5877H173.594V82.6623Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M119.801 62.0055C118.749 60.0178 117.55 58.1484 116.218 56.7337C115.842 56.3177 115.34 56.0363 114.788 55.9328C114.236 55.8293 113.666 55.9094 113.164 56.1608C113.453 56.3046 113.714 56.4986 113.935 56.7337C115.264 58.1484 116.466 60.0178 117.515 62.0055C120.625 67.9869 122.234 74.6325 122.202 81.3712V151.524H124.488V81.3739C124.519 74.6345 122.91 67.9882 119.801 62.0055Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M164.807 62.1991C165.855 60.2114 167.058 58.3421 168.387 56.9273C168.635 56.6594 168.936 56.4451 169.271 56.2979C168.777 56.0822 168.227 56.0268 167.7 56.1398C167.173 56.2527 166.694 56.5282 166.333 56.9273C165.001 58.3421 163.799 60.2114 162.75 62.1991C159.641 68.1811 158.032 74.8263 158.062 81.5649V151.728H160.119V81.5702C160.087 74.8297 161.696 68.1822 164.807 62.1991Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M114.526 174.736H114.35C113.525 174.736 112.734 174.409 112.151 173.827C111.567 173.245 111.24 172.455 111.24 171.632V157.414H117.636V171.632C117.636 172.455 117.309 173.245 116.725 173.827C116.142 174.409 115.351 174.736 114.526 174.736Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.311 174.736H135.133C134.309 174.735 133.518 174.408 132.936 173.826C132.353 173.244 132.025 172.455 132.025 171.632V157.414H138.419V171.632C138.419 172.455 138.092 173.244 137.509 173.826C136.926 174.408 136.136 174.735 135.311 174.736Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.329 174.736H148.148C147.324 174.734 146.535 174.406 145.954 173.824C145.372 173.242 145.045 172.454 145.045 171.632V157.414H151.439V171.632C151.439 172.455 151.112 173.245 150.528 173.827C149.945 174.409 149.154 174.736 148.329 174.736Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.343 174.736H169.173C168.764 174.736 168.359 174.657 167.981 174.501C167.603 174.345 167.26 174.117 166.97 173.829C166.681 173.54 166.451 173.198 166.294 172.821C166.138 172.444 166.057 172.04 166.057 171.632V157.414H172.451V171.632C172.451 172.455 172.124 173.244 171.541 173.826C170.958 174.408 170.168 174.735 169.343 174.736Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.926 1.81557C143.592 1.41905 143.176 1.10026 142.705 0.881544C142.234 0.662831 141.722 0.5495 141.203 0.5495C140.683 0.5495 140.171 0.662831 139.7 0.881544C139.23 1.10026 138.813 1.41905 138.479 1.81557C136.592 3.93505 134.867 6.73501 133.357 9.71519C128.92 18.5481 126.667 28.5753 126.667 38.7423V151.335H155.509V38.2905C155.509 28.4112 153.353 18.6557 149.137 10.0218C147.156 5.92542 145.331 3.37828 143.926 1.81557Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.463 14.3226H136.341C134.704 14.3226 133.376 15.6472 133.376 17.2813V18.2469C133.376 19.8809 134.704 21.2055 136.341 21.2055H145.463C147.101 21.2055 148.428 19.8809 148.428 18.2469V17.2813C148.428 15.6472 147.101 14.3226 145.463 14.3226Z",
  fill: "#535461"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M155.372 42.5913H126.823V43.6967H155.372V42.5913Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M205.147 83.7381C204.398 82.7572 203.462 81.9344 202.392 81.3174C201.162 80.6102 199.787 80.1944 198.371 80.1024C196.955 80.0103 195.536 80.2445 194.226 80.7866C192.915 81.3288 191.746 82.1645 190.811 83.2291C189.875 84.2937 189.198 85.5588 188.831 86.9264C188.463 88.294 188.416 89.7276 188.693 91.1163C188.969 92.505 189.562 93.8117 190.426 94.9353C191.289 96.0589 192.4 96.9693 193.672 97.5961C194.945 98.2229 196.344 98.5494 197.763 98.5503C197.96 98.5503 198.157 98.5503 198.348 98.5287C200.016 98.4237 201.624 97.87 203.002 96.9263C204.379 95.9826 205.475 94.6842 206.173 93.169C206.87 91.6538 207.143 89.9784 206.963 88.3207C206.783 86.663 206.156 85.085 205.149 83.7543L205.147 83.7381Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M206.508 89.3004C206.507 91.5196 205.66 93.6552 204.138 95.2731C202.615 96.8909 200.533 97.8695 198.313 98.0097C198.133 98.0097 197.947 98.0285 197.761 98.0285C196.418 98.0293 195.093 97.7218 193.889 97.1298C192.684 96.5378 191.633 95.6772 190.815 94.6146C189.997 93.552 189.436 92.3159 189.174 91.002C188.912 89.6881 188.956 88.3317 189.304 87.0377C189.651 85.7437 190.293 84.5468 191.178 83.5398C192.063 82.5328 193.169 81.7426 194.41 81.2304C195.65 80.7181 196.993 80.4977 198.332 80.586C199.672 80.6743 200.973 81.0691 202.135 81.7397C203.149 82.3263 204.034 83.1091 204.739 84.0421C205.889 85.555 206.51 87.4019 206.508 89.3004Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M195.607 83.7623C195.155 83.9565 194.719 84.1859 194.302 84.4482C194.025 84.5997 193.786 84.8133 193.604 85.0722C193.514 85.2027 193.465 85.3566 193.462 85.515C193.459 85.6733 193.503 85.8289 193.588 85.9625C193.801 86.253 194.211 86.296 194.572 86.3176C194.951 86.3658 195.337 86.3271 195.699 86.2046C195.943 86.0839 196.166 85.923 196.357 85.7285L197.109 85.048C197.378 84.8113 197.648 84.4859 197.543 84.1524C197.48 84.0332 197.389 83.9315 197.278 83.8563C197.166 83.7812 197.038 83.735 196.904 83.722C196.255 83.596 195.583 83.7138 195.017 84.0528",
  fill: "black"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M192.466 93.2059C192.721 93.2059 192.927 92.9999 192.927 92.7459C192.927 92.4919 192.721 92.286 192.466 92.286C192.212 92.286 192.005 92.4919 192.005 92.7459C192.005 92.9999 192.212 93.2059 192.466 93.2059Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M201.826 91.5194C202.758 91.5194 203.513 90.7656 203.513 89.8357C203.513 88.9058 202.758 88.1519 201.826 88.1519C200.894 88.1519 200.138 88.9058 200.138 89.8357C200.138 90.7656 200.894 91.5194 201.826 91.5194Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M204.755 84.0421C204.75 84.4823 204.619 84.9118 204.376 85.2795C204.134 85.6472 203.79 85.9376 203.387 86.1162C202.984 86.2947 202.537 86.3538 202.101 86.2865C201.665 86.2192 201.258 86.0282 200.928 85.7364C200.597 85.4446 200.358 85.0642 200.238 84.6406C200.118 84.2169 200.123 83.7678 200.251 83.3467C200.38 82.9256 200.627 82.5502 200.964 82.2653C201.3 81.9804 201.711 81.798 202.149 81.7397C203.163 82.326 204.049 83.1088 204.755 84.0421Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M204.912 94.3248C204.159 95.3935 203.176 96.2797 202.033 96.9175C200.891 97.5554 199.62 97.9287 198.313 98.0096C198.313 97.8886 198.297 97.7676 198.297 97.6438C198.298 96.8779 198.511 96.1272 198.915 95.4753C199.318 94.8235 199.894 94.2961 200.58 93.952C201.266 93.6079 202.034 93.4605 202.799 93.5264C203.564 93.5922 204.295 93.8686 204.912 94.3248Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M85.6556 133.565C85.1337 132.876 84.4793 132.298 83.7309 131.865C82.872 131.362 81.9083 131.064 80.9149 130.993C79.9215 130.923 78.9252 131.083 78.0038 131.46C77.0823 131.836 76.2604 132.42 75.6022 133.166C74.944 133.912 74.4672 134.799 74.209 135.759C73.9508 136.719 73.9181 137.725 74.1136 138.699C74.309 139.674 74.7272 140.59 75.3356 141.377C75.9441 142.163 76.7263 142.799 77.6214 143.235C78.5166 143.67 79.5004 143.894 80.4962 143.888C80.6337 143.888 80.7658 143.888 80.906 143.874C82.0674 143.796 83.1863 143.407 84.1445 142.748C85.1028 142.088 85.865 141.183 86.3507 140.127C86.8365 139.072 87.0278 137.905 86.9045 136.75C86.7812 135.595 86.3479 134.494 85.6502 133.565H85.6556Z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M86.6046 137.446C86.6043 138.994 86.0129 140.484 84.9509 141.613C83.8888 142.741 82.4358 143.424 80.8872 143.522C80.7605 143.522 80.6177 143.522 80.5018 143.522C79.5658 143.522 78.6424 143.307 77.803 142.893C76.9637 142.48 76.2308 141.88 75.6611 141.139C75.0914 140.398 74.7002 139.536 74.5176 138.62C74.335 137.704 74.3661 136.759 74.6083 135.856C74.8505 134.954 75.2975 134.12 75.9145 133.418C76.5316 132.716 77.3023 132.164 78.1669 131.807C79.0316 131.449 79.9671 131.295 80.9011 131.356C81.8351 131.417 82.7425 131.691 83.5532 132.158C84.2611 132.569 84.8789 133.118 85.37 133.772C86.1737 134.829 86.6074 136.119 86.6046 137.446Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M78.9974 133.583C78.6821 133.717 78.3783 133.877 78.0889 134.06C77.896 134.167 77.7294 134.316 77.601 134.495C77.5411 134.588 77.5093 134.696 77.5093 134.806C77.5093 134.916 77.5411 135.024 77.601 135.117C77.6905 135.205 77.798 135.273 77.9162 135.315C78.0344 135.358 78.1604 135.375 78.2857 135.364C78.5506 135.398 78.8198 135.372 79.0728 135.286C79.2442 135.202 79.4001 135.089 79.5338 134.953L80.0567 134.479C80.24 134.312 80.4395 134.086 80.3586 133.855C80.3174 133.77 80.2546 133.698 80.1766 133.645C80.0985 133.592 80.0079 133.561 79.9139 133.554C79.4627 133.466 78.9947 133.548 78.6011 133.785",
  fill: "black"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M76.8056 140.168C76.9828 140.168 77.1264 140.025 77.1264 139.848C77.1264 139.671 76.9828 139.528 76.8056 139.528C76.6285 139.528 76.4849 139.671 76.4849 139.848C76.4849 140.025 76.6285 140.168 76.8056 140.168Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M83.3376 138.995C83.9882 138.995 84.5156 138.469 84.5156 137.82C84.5156 137.171 83.9882 136.644 83.3376 136.644C82.6871 136.644 82.1597 137.171 82.1597 137.82C82.1597 138.469 82.6871 138.995 83.3376 138.995Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M85.3728 133.777C85.3704 134.087 85.2785 134.39 85.1082 134.649C84.9378 134.909 84.6963 135.113 84.4123 135.239C84.1284 135.365 83.8141 135.407 83.5071 135.359C83.2 135.312 82.9133 135.177 82.681 134.971C82.4488 134.765 82.2809 134.496 82.1975 134.198C82.1141 133.899 82.1187 133.583 82.2107 133.287C82.3027 132.99 82.4783 132.727 82.7164 132.528C82.9545 132.329 83.245 132.202 83.5533 132.163C84.2622 132.574 84.881 133.123 85.3728 133.777Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M85.4913 140.951C84.9663 141.696 84.2798 142.315 83.4829 142.76C82.6859 143.205 81.7988 143.465 80.8872 143.522C80.8872 143.439 80.8872 143.352 80.8872 143.253C80.8877 142.719 81.0369 142.195 81.3181 141.74C81.5993 141.285 82.0016 140.917 82.48 140.677C82.9585 140.437 83.4944 140.334 84.0279 140.38C84.5615 140.426 85.0719 140.619 85.5021 140.937L85.4913 140.951Z",
  fill: "black"
})), /*#__PURE__*/React.createElement("path", {
  d: "M257.404 115.676C257.678 115.676 257.9 115.454 257.9 115.181C257.9 114.907 257.678 114.686 257.404 114.686C257.13 114.686 256.908 114.907 256.908 115.181C256.908 115.454 257.13 115.676 257.404 115.676Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 74.7922,
  y1: 187.501,
  x2: 74.7922,
  y2: 180.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 4845.09,
  y1: 3661.07,
  x2: 4845.09,
  y2: 3518.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 43768.2,
  y1: 126339,
  x2: 43768.2,
  y2: 7662.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 114.439,
  y1: 157.414,
  x2: 114.439,
  y2: 174.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#FCCC63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#F55F44"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 3546.72,
  y1: 11037.8,
  x2: 3546.72,
  y2: 12153.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#FCCC63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#F55F44"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 3868.59,
  y1: 11037.8,
  x2: 3868.59,
  y2: 12153.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#FCCC63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#F55F44"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 4388,
  y1: 11037.8,
  x2: 4388,
  y2: 12153.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#FCCC63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#F55F44"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 14361.9,
  y1: 7637.5,
  x2: 14361.9,
  y2: 6369.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 4362.12,
  y1: 7591.33,
  x2: 4362.12,
  y2: 6972.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 219,
  fill: "white"
})));

var SvgSpaceship = function SvgSpaceship(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 219,
    viewBox: "0 0 306 219",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpaceship, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spaceship.b5d06f02.svg";
export { ForwardRef as ReactComponent };